module.exports = __webpack_public_path__ + "static/img/petlosteden.23c6083.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/petlosteden.png
// module id = LSJl
// module chunks = 0